<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toch">Table of Contents</h1>
<p class="ptt"><a href="#/part1">Part One</a></p>
<p class="toc"><a href="#/chapter1">Chapter 1      A EUNUCH SLAVE’S LIFE</a></p>
<p class="toc"><a href="#/chapter2">Chapter 2      OBLIGATION</a></p>
<p class="toc"><a href="#/chapter3">Chapter 3      A DREAM</a></p>
<p class="toc"><a href="#/chapter4">Chapter 4      THE LONELY ONE</a></p>
<p class="toc"><a href="#/chapter5">Chapter 5      THE RULER OF THE WORLD</a></p>
<p class="toc"><a href="#/chapter6">Chapter 6      PURIFICATION</a></p>
<p class="toc"><a href="#/chapter7">Chapter 7      THE PEOPLE</a></p>
<p class="toc"><a href="#/chapter8">Chapter 8      JOINING HEAVEN AND EARTH</a></p>
<p class="toc"><a href="#/chapter9">Chapter 9      GOVERNMENT</a></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10    A EUNUCH SLAVE’S WORLD</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11    A EUNUCH SLAVE’’S DISCIPLINE</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12    THE LAST YEAR</span></p>
<p class="center"><span href="#/part2" title="Link target outside of Sample">Part Two</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Chapter 13    THE GREAT ANNUAL SACRIFICE</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">Chapter 14    FEAST AND PROCLAMATION</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">Chapter 15    THE HEART OF WE WHO SERVE</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">Chapter 16    CONTINUITY</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">Chapter 17    THE FIRST YEAR</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">Chapter 18    SCHEDULE</span></p>
<p class="toc"><span href="#/chapter19" title="Link target outside of Sample">Chapter 19    THE QUOTIDIAN</span></p>
<p class="toc"><span href="#/chapter20" title="Link target outside of Sample">Chapter 20    A EUNUCH SLAVE’S WAY</span></p>
<p class="toc"><span href="#/chapter21" title="Link target outside of Sample">Chapter 21    THE SECOND, THIRD AND FOURTH YEARS</span></p>
<p class="toc"><span href="#/chapter22" title="Link target outside of Sample">Chapter 22    THE KARMAPA</span></p>
<p class="toc"><span href="#/chapter23" title="Link target outside of Sample">Chapter 23    THE FIFTH THROUGH EIGHTH YEARS</span></p>
<p class="toc"><span href="#/chapter24" title="Link target outside of Sample">Chapter 24    WORDS</span></p>
<p class="toc"><span href="#/chapter25" title="Link target outside of Sample">Chapter 25    WORDS AND A EUNUCH SLAVE</span></p>
<p class="toc"><span href="#/chapter26" title="Link target outside of Sample">Chapter 26    THE ASPIRATION OF A EUNUCH SLAVE</span></p>
<p class="toc"><span href="#/chapter27" title="Link target outside of Sample">Chapter 27    NINTH THROUGH FIFTEENTH YEARS: 1</span></p>
<p class="toc"><span href="#/chapter28" title="Link target outside of Sample">Chapter 28    AUDIENCE WITH GRAND SECRETARY</span></p>
<p class="toc"><span href="#/chapter29" title="Link target outside of Sample">Chapter 29    NINTH THROUGH FIFTEENTH YEARS: 2</span></p>
<p class="toc"><span href="#/chapter30" title="Link target outside of Sample">Chapter 30    DICTATIONS</span></p>
<p class="toc"><span href="#/chapter30#ch30_1" title="Link target outside of Sample">1- NIGHTMARE</span></p>
<p class="toc0"><span href="#/chapter30#ch30_2" title="Link target outside of Sample">2- LAW AND PUNISHMENT</span></p>
<p class="toc"><span href="#/chapter31" title="Link target outside of Sample">Chapter 31    THE LORD OF DEATH</span></p>
<p class="center"><span href="#/part3" title="Link target outside of Sample">Part Three</span></p>
<p class="toc"><span href="#/chapter32" title="Link target outside of Sample">Chapter 32    SIXTEENTH THROUGH EIGHTEENTH YEARS</span></p>
<p class="toc"><span href="#/chapter33" title="Link target outside of Sample">Chapter 33    STORY</span></p>
<p class="toc"><span href="#/chapter34" title="Link target outside of Sample">Chapter 34    FIRST OFFERING TO HEAVEN IN BEIJING</span></p>
<p class="toc"><span href="#/chapter35" title="Link target outside of Sample">Chapter 35    DICTATION</span></p>
<p class="toc"><span href="#/chapter36" title="Link target outside of Sample">Chapter 36    NINETEENTH YEAR: 1</span></p>
<p class="toc"><span href="#/chapter37" title="Link target outside of Sample">Chapter 37    NINETEENTH YEAR: 2</span></p>
<p class="toc"><span href="#/chapter38" title="Link target outside of Sample">Chapter 38    DICTATION - REALITY</span></p>
<p class="toc"><span href="#/chapter39" title="Link target outside of Sample">Chapter 39    TWENTIETH AND TWENTY - FIRST YEAR</span></p>
<p class="toc"><span href="#/chapter40" title="Link target outside of Sample">Chapter 40    A EUNUCH SLAVE’S FAREWELL</span></p>
<p class="toc"><span href="#/chapter41" title="Link target outside of Sample">Chapter 41    THE LAST YEAR</span></p>
<p class="toc"><span href="#/chapter42" title="Link target outside of Sample">Chapter 42    THE LAST DICTATION - OCEAN OF FIRE</span></p>
<p class="toc"><span href="#/chapter43" title="Link target outside of Sample">Chapter 43    A EUNUCH SLAVE’S DREAM</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nameoftocfile.vue?2947cb04